<div class="thank-you-img">
  <img src="/assets/image/thankyou-confirm.png" alt="" />
</div>
<div class="thank-you-text">
  <h4>{{'Account Created successfully'}}</h4>
  <p>
    {{'You have successfully created your account.'}}
  </p>
  <p>
  {{'You can close this window and continue to login'}}
</p>
</div>